import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Divider, Input, MenuItem, Select } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import apiService from '../../api/apiService';
import SaveButton from '../Common/SaveButton';
import { useAsyncCallback } from '../../hooks/useAsyncCallback';

export default function RiskControlModal (props) {
    const { onClose, open, controlTypes, hazardId, ...other } = props;
    const { t } = useTranslation();
    const [description, setDescription] = useState('');
    const [currentControlType, setCurrentControlType] = useState({});
    const [controlLink, setControlLink] = useState('');

    const handleCancel = () => {
        resetModal();
        onClose(false);
    };

    const { run: handleSave, loading: saving } = useAsyncCallback(async () => {
        if (!description) {
            return;
        }

        if (Object.keys(currentControlType).length === 0) {
            return;
        }

        await apiService.postData('/api/Hazard/hazardControl', {
            HcHazard: hazardId,
            HcDescription: description,
            HcControlType: controlTypes.find(controlType => controlType.ctName === currentControlType).ctId,
            controlLink: controlLink,
        });

        resetModal();
        onClose(true);
    });

    const resetModal = () => {
        setDescription('');
        setCurrentControlType({});
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '100%' } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle variant="h4">{t('riskControl.title')}</DialogTitle>
            <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.5)' }} />
            <DialogContent>
                <Typography variant="h5">
                    {t('fieldName.description')}
                </Typography>
                <Input
                    type="text"
                    name="department"
                    value={description}
                    sx={{ width: '100%', marginBottom: '30px' }}
                    onChange={(event) => {
                        setDescription(event.target.value);
                    }}
                />
                <Typography variant="h5">
                    {t('riskControl.field.urlToResource')}
                </Typography>
                <Input
                    type="text"
                    name="department"
                    value={controlLink}
                    sx={{ width: '100%', marginBottom: '30px' }}
                    onChange={(event) => {
                        setControlLink(event.target.value);
                    }}
                />
                <Typography variant="h5">
                    {t('riskControl.field.controlType')}
                </Typography>
                <Select
                    sx={{ width: '100%' }}
                    name="Control Type"
                    value={Object.keys(currentControlType).length > 0 ? currentControlType : ''}
                    onChange={(event) => {
                        setCurrentControlType(event.target.value);
                    }}
                >
                    {controlTypes.map((controlType) => (
                        <MenuItem key={controlType.ctId} value={controlType.ctName}>
                            {controlType.localizedName ?? controlType.ctName}
                        </MenuItem>
                    ))}
                </Select>
            </DialogContent>
            <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.5)' }} />
            <DialogActions>
                <Button onClick={handleCancel} color="primary" disabled={saving}>
                    {t('common.cancel')}
                </Button>
                <SaveButton loading={saving} onClick={handleSave} color="primary" variant="contained">
                    {t('common.save')}
                </SaveButton>
            </DialogActions>
        </Dialog>
    );
}

RiskControlModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    controlTypes: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    hazardId: PropTypes.string.isRequired,
};
